<script>
export default {
  name: "FooterAccBar",
  components: {
  },
  data() {
    return {
      activeLink: "",
    };
  },
  methods: {
    toggleActive(link) {
      this.activeLink = this.activeLink === link ? "" : link;
      this.$emit("toggleStage", link);
    },
  },
  mounted() {
    this.toggleActive("profile");
  },
};
</script>
<template>
  <div class="bar">
    <router-link class="bar__link" @click="toggleActive('profile')" :class="{ active: activeLink === 'profile' }" to="">
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path opacity="0.4"
          d="M18.1394 21.62C17.2594 21.88 16.2194 22 14.9994 22H8.99937C7.77937 22 6.73937 21.88 5.85938 21.62C6.07937 19.02 8.74937 16.97 11.9994 16.97C15.2494 16.97 17.9194 19.02 18.1394 21.62Z"
          stroke="#1A1A1A" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
        <path
          d="M22 9V15C22 18.78 20.86 20.85 18.14 21.62C17.26 21.88 16.22 22 15 22H9C7.78 22 6.74 21.88 5.86 21.62C3.14 20.85 2 18.78 2 15V9C2 4 4 2 9 2H15C20 2 22 4 22 9Z"
          stroke="#1A1A1A" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
        <path opacity="0.4"
          d="M15.5799 10.58C15.5799 12.56 13.9799 14.17 11.9999 14.17C10.0199 14.17 8.41992 12.56 8.41992 10.58C8.41992 8.60002 10.0199 7 11.9999 7C13.9799 7 15.5799 8.60002 15.5799 10.58Z"
          stroke="#1A1A1A" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
      </svg>
    </router-link>
    <router-link class="bar__link" @click="toggleActive('vacancy')" :class="{ active: activeLink === 'vacancy' }" to="">
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M21.6602 10.44L20.6802 14.62C19.8402 18.23 18.1802 19.69 15.0602 19.39C14.5602 19.35 14.0202 19.26 13.4402 19.12L11.7602 18.72C7.59018 17.73 6.30018 15.67 7.28018 11.49L8.26018 7.30001C8.46018 6.45001 8.70018 5.71001 9.00018 5.10001C10.1702 2.68001 12.1602 2.03001 15.5002 2.82001L17.1702 3.21001C21.3602 4.19001 22.6402 6.26001 21.6602 10.44Z"
          stroke="#1A1A1A" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
        <path opacity="0.4"
          d="M15.0603 19.3901C14.4403 19.8101 13.6603 20.1601 12.7103 20.4701L11.1303 20.9901C7.16034 22.2701 5.07034 21.2001 3.78034 17.2301L2.50034 13.2801C1.22034 9.3101 2.28034 7.2101 6.25034 5.9301L7.83034 5.4101C8.24034 5.2801 8.63034 5.1701 9.00034 5.1001C8.70034 5.7101 8.46034 6.4501 8.26034 7.3001L7.28034 11.4901C6.30034 15.6701 7.59034 17.7301 11.7603 18.7201L13.4403 19.1201C14.0203 19.2601 14.5603 19.3501 15.0603 19.3901Z"
          stroke="#1A1A1A" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
        <path opacity="0.4" d="M12.6406 8.53003L17.4906 9.76003" stroke="#1A1A1A" stroke-width="1.5"
          stroke-linecap="round" stroke-linejoin="round" />
        <path opacity="0.4" d="M11.6602 12.4L14.5602 13.14" stroke="#1A1A1A" stroke-width="1.5" stroke-linecap="round"
          stroke-linejoin="round" />
      </svg>
    </router-link>
    <router-link class="bar__link" @click="toggleActive('message')" :class="{ active: activeLink === 'message' }" to="">
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path opacity="0.4" d="M8.5 10.5H15.5" stroke="#1A1A1A" stroke-width="1.5" stroke-miterlimit="10"
          stroke-linecap="round" stroke-linejoin="round" />
        <path
          d="M7 18.4299H11L15.45 21.39C16.11 21.83 17 21.3599 17 20.5599V18.4299C20 18.4299 22 16.4299 22 13.4299V7.42993C22 4.42993 20 2.42993 17 2.42993H7C4 2.42993 2 4.42993 2 7.42993V13.4299C2 16.4299 4 18.4299 7 18.4299Z"
          stroke="#1A1A1A" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
      </svg>
    </router-link>
    <router-link class="bar__link" @click="toggleActive('favorites')" :class="{ active: activeLink === 'favorites' }" to="">
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M12.62 20.81C12.28 20.93 11.72 20.93 11.38 20.81C8.48 19.82 2 15.69 2 8.68998C2 5.59998 4.49 3.09998 7.56 3.09998C9.38 3.09998 10.99 3.97998 12 5.33998C13.01 3.97998 14.63 3.09998 16.44 3.09998C19.51 3.09998 22 5.59998 22 8.68998C22 15.69 15.52 19.82 12.62 20.81Z"
          stroke="#1A1A1A" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
      </svg>
    </router-link>
    <a class="bar__link">
      <svg width="20" height="16" viewBox="0 0 20 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M1 1H19" stroke="#1A1A1A" stroke-width="1.5" stroke-linecap="round" />
        <path opacity="0.34" d="M1 8H19" stroke="#1A1A1A" stroke-width="1.5" stroke-linecap="round" />
        <path d="M1 15H19" stroke="#1A1A1A" stroke-width="1.5" stroke-linecap="round" />
      </svg>
    </a>
  </div>
</template>

<style scoped lang="scss">
  .bar {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    display: flex;
    justify-content: space-around;
    gap: 15px;
    align-items: center;
    border: 1px solid rgba(178, 190, 195, 1);
    padding: 15px 0 30px;
    background: #fff;
    &__link {
      &.active {
        path {
          stroke: #70f;
        }
      }
    }
  }
</style>